/* @flow */

import * as React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { withRouter } from 'next/router';
// $FlowFixMe
import { Breadcrumb } from '@bijie/react-bnb';

import withi18n from '../../../utils/withI18n';
import { getLabel } from '../../../utils/i18n';
import { Link } from '../../../routes';
import Container from '../../Container';

const Wrap = styled.div`
  width: 100%;
  line-height: 100%;
`;

const MainNavBox = styled.div`
  width: 100%;
  padding: 20px 0;
  background: #fff;
  box-shadow:0px 2px 10px 0px rgba(0,0,0,0.1);

  .breadcrumb {
    > .breadcrumb-separator {
      padding: 0 21px;
      font-size:14px;
      font-weight:600;
    }

    > .breadcrumb-item {
      font-size: 12px;
      font-family: ${({ theme }) => theme.fontIBMRegular};
      color: #48515d;

      &:not(:last-child):hover {
        color: #f0b90b;
        cursor: pointer;
      }

      a {
        color: inherit;
      }
    }
  }
`;

const NavContainer = styled(Container)`
  width: 100%;
`;

type Props = {
  i18n: Object,
  locale: string,
  crumbInfo: Object,
};

const mapStateToProps = ({ locale }) => ({ locale });

export default
@withi18n
@withRouter
@connect(mapStateToProps)
class Header extends React.PureComponent<Props> {
  static defaultProps = {
    i18n: {},
    locale: 'en',
    crumbInfo: {},
  };

  render() {
    const {
      i18n, locale, crumbInfo,
    } = this.props;
    return (
      <Wrap>
        <MainNavBox>
          <NavContainer>
            <Breadcrumb separator=">">
              {
                Object.keys(crumbInfo) && Object.keys(crumbInfo).map((v, i) => (
                  <Breadcrumb.Item key={i}>
                    {
                      crumbInfo[v] ?
                        <Link route={`/${locale}${crumbInfo[v]}`}>
                          <a>{getLabel(v, i18n)}</a>
                        </Link>
                        : getLabel(v, i18n)
                    }
                  </Breadcrumb.Item>
                ))
              }
            </Breadcrumb>
          </NavContainer>
        </MainNavBox>
      </Wrap>
    );
  }
}
